export const initial = { opacity: 0, y: -10 };
export const animate = { opacity: 1, y: 0 };
export const exit = { opacity: 0, y: -10 };
